import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ReactGA from 'react-ga';

ReactGA.initialize('G-3QG45Y0Q8K');
ReactDOM.render(<App />, document.getElementById('root'));
